import { render, staticRenderFns } from "./BranchStocksPage.vue?vue&type=template&id=16e31b94"
import script from "./BranchStocksPage.vue?vue&type=script&lang=js"
export * from "./BranchStocksPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports